import { type QueryFunctionContext } from '@tanstack/vue-query';

import type { ApiResponse } from '@abaninja/types';

import { apiClient, unwrap } from '@abaninja/util-http-client';

import type { User, UserRequest } from '../@types';

export function getUsers(options?: QueryFunctionContext) {
  return unwrap(apiClient.get<ApiResponse<User[]>>('/users/v1/users', { signal: options?.signal }));
}

export function getUser(userUuid: string, options?: QueryFunctionContext) {
  return unwrap(apiClient.get<ApiResponse<User>>(`/users/v1/users/${userUuid}`, { signal: options?.signal }));
}

export function createUser(data: UserRequest) {
  return unwrap(apiClient.post<ApiResponse<User>>('/users/v1/users', data));
}

export function updateUser({ data, userUuid }: { data: UserRequest; userUuid: string }) {
  return unwrap(apiClient.patch<ApiResponse<User>>(`/users/v1/users/${userUuid}`, data));
}

export function deleteUser(userUuid: string) {
  return unwrap(apiClient.delete(`/users/v1/users/${userUuid}`));
}
